import React from "react";

export default function Card({
  height = null,
  width = null,
  expand = false,
  fit = false,
  children,
}) {
  const styles = {};
  if (height) {
    styles.height = `${height}px`;
    styles.maxHeight = `${height}px`;
  }

  if (width) {
    styles.width = `${width}px`;
  }

  return (
    <div
      className={`card ${expand ? "card--expand" : ""}${
        fit ? "card--fit" : ""
      }`}
      style={styles}
    >
      {children}
    </div>
  );
}
